module.exports = __webpack_public_path__ + "static/profile-pic2.b79a8cfb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/profile-pic2.jpg
// module id = 404
// module chunks = 35783957827783 107818501498521